module.exports = __webpack_public_path__ + "static/media/add_card.4aa8dc5f.svg";